module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p11-b58225f2d404862b72eb18d8913308f1.png";